import {
  FETCH_TRANSFERS_PENDING,
  FETCH_TRANSFERS_REJECTED,
  FETCH_TRANSFERS_FULFILLED,
} from "../constants/transfers";

const initialState = {
  pending: true, 
  transfers: [],
  error: {},
};

export const transfers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRANSFERS_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_TRANSFERS_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_TRANSFERS_FULFILLED:
      return {
        ...state,
        transfers: action.response.results,
        pending: false,
        error: {}
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/transfers.js